<template>
  <daiban-tool :flow="flow"> </daiban-tool>
</template>
<script>
import daibanTool from "./daibanTool.vue";
export default {
  components: { daibanTool },
  data() {
    return {
      flow: {
        id: "1627969124636323842",
        name: "应急管理",
        name1: "应急待办处理",
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/daibanchuli2.vue